import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import css from '../../styles.css';

function SettingsCardWrapper({ titleId, defaultTitle, icon: Icon, children }) {
  return (
    <Card
      headerStart={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '16px',
            fontWeight: '600',
            gap: '10px',
          }}
        >
          <Icon size={16} />
          <FormattedMessage id={titleId} defaultMessage={defaultTitle} />
        </div>
      }
      cardClass={css.card_class}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {children}
      </div>
    </Card>
  );
}

SettingsCardWrapper.propTypes = {
  titleId: PropTypes.string.isRequired,
  defaultTitle: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
};

export default SettingsCardWrapper;
